var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.76,
    height: 21.618,
    viewBox: "0 0 20.76 21.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.924 -14.836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.583,24.823a7.857,7.857,0,0,0,.1-1.014,8.216,8.216,0,0,0-.1-1.014l1.948-1.474a1.082,1.082,0,0,0,.283-1.4l-1.749-3.027a1.081,1.081,0,0,0-1.355-.456l-2.242.945A8.032,8.032,0,0,0,26.7,16.327l-.3-2.38A1.082,1.082,0,0,0,25.327,13h-3.5a1.081,1.081,0,0,0-1.072.947l-.3,2.38A8.066,8.066,0,0,0,18.69,17.38l-2.242-.945a1.079,1.079,0,0,0-1.355.456l-1.749,3.027a1.083,1.083,0,0,0,.283,1.4L15.575,22.8a7.856,7.856,0,0,0-.1,1.014,8.216,8.216,0,0,0,.1,1.014L13.627,26.3a1.082,1.082,0,0,0-.283,1.4l1.749,3.029a1.081,1.081,0,0,0,1.355.456l2.242-.947a8.032,8.032,0,0,0,1.771,1.053l.3,2.38a1.079,1.079,0,0,0,1.07.947h3.5a1.081,1.081,0,0,0,1.072-.947l.3-2.38a8.066,8.066,0,0,0,1.771-1.053l2.242.945a1.079,1.079,0,0,0,1.355-.456L33.812,27.7a1.083,1.083,0,0,0-.283-1.4Zm-8.005,3.31A4.324,4.324,0,1,1,27.9,23.809,4.322,4.322,0,0,1,23.578,28.133Z",
    transform: "translate(1.725 1.836)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f89b4c2c18c995a488fe20b9d8582518.svg";
export { ForwardRef as ReactComponent };